import { render, staticRenderFns } from "./OnlyOneAudio.vue?vue&type=template&id=5efa7e35&scoped=true&"
import script from "./OnlyOneAudio.vue?vue&type=script&lang=js&"
export * from "./OnlyOneAudio.vue?vue&type=script&lang=js&"
import style0 from "./OnlyOneAudio.vue?vue&type=style&index=0&id=5efa7e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa7e35",
  null
  
)

export default component.exports